import React from 'react';
import { Box, Typography } from '.';

export default function Jobs() {
  return (
    <Box>
      <Typography variant="heading3" mb={6}>
        Interested to work with us?
      </Typography>
      <Typography variant="paragraph1" mb={6}>
        We don't have any open positions at the moment, but we're always happy
        to hear from talented people. Feel free to send your CV to{' '}
        <a href="mailto:career-program@springrain.io" style={{ color: '#188DCD', textDecoration: 'underline' }}>
          career-program@springrain.io
        </a>
        .
      </Typography>
    </Box>
  );
}
